module.exports = __webpack_public_path__ + "static/media/image1.77e17e7b.jpg";